// Enhanced Ecommerce dataLayers
window.gtm = {
	addToCart(productId, productName, price, quantity, currency = 'CZK') {
		if (!window.laravel.enableGtm) return;
        if (typeof dataLayer === "undefined") return;

	    price = price.toFixed(2);
		dataLayer.push({
			'event': 'addToCart',
            'currencyCode': currency,
			'ecommerce': {
				'currencyCode': window.laravel.currency,
				'add': {
					'products': [{
						'name': productName,
						'id': productId,
						'price': price,
						'quantity': quantity
					}]
				}
			}
		});
	},

	removeFromCart(productId, productName, price, quantity, currency = 'CZK') {
		if (!window.laravel.enableGtm) return;
        if (typeof dataLayer === "undefined") return;

        price = price.toFixed(2);
		dataLayer.push({
			'event': 'removeFromCart',
            'currencyCode': currency,
			'ecommerce': {
				'remove': {
					'products': [{
						'name': productName,
						'id': productId,
						'price': price,
						'quantity': quantity
					}]
				}
			}
		});

	},

	checkout(step, products, currency = 'CZK') {
		if (!window.laravel.enableGtm) return;
        if (typeof dataLayer === "undefined") return;

		dataLayer.push({
			'event': 'checkout',
            'currencyCode': currency,
			'ecommerce': {
				'checkout': {
					'actionField': {
						'step': step
					},
					'products': products
				}
			}
		});
	},

	trackTransaction(data, currency = 'CZK') {
		if (!window.laravel.enableGtm) return;
        if (typeof dataLayer === "undefined") return;

		dataLayer.push({
			'event': 'trackTransaction',
            'currencyCode': currency,
			'ecommerce': {
				'purchase': {
					'actionField': data
				}
			}
		});
	},

	registrationComplete() {
		if (!window.laravel.enableGtm) return;
        if (typeof dataLayer === "undefined") return;

		dataLayer.push({'event': 'complete_registration'});
	}
};
